import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.31 0a15.94 15.94 0 1 0 0 31.91A15.94 15.94 0 0 0 16.3 0zm0 31.02A15.07 15.07 0 1 1 16.32.9a15.07 15.07 0 0 1 0 30.12z" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M25.96 15.51c-.27 0-.45.18-.45.44 0 5.07-4.13 9.2-9.2 9.2s-9.2-4.13-9.2-9.2c0-.26-.18-.44-.44-.44s-.45.18-.45.45a10.1 10.1 0 0 0 20.18 0 .45.45 0 0 0-.44-.45M12.89 9.38a.98.98 0 1 1-1.96 0 .98.98 0 0 1 1.96 0m8.75 0a.98.98 0 1 1-1.95 0 .98.98 0 0 1 1.95 0" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }